import {AxiosClientFactory} from "../../common/helpers/AxiosClientFactory";
import {CommandResult} from "../../common/helpers/CommandResult";
import {LaunchCampaignModel} from "../../common/models/Campaign";

export const launchCampaign = (campaign: LaunchCampaignModel): Promise<CommandResult> => {
    return AxiosClientFactory
        .getInstance()
        .post(`/api/campaigns/launch`, campaign)
        .then((result) =>new CommandResult(result));
};